import type { InstructionStep } from "../../components/Instructions";

export interface ShortcutItem {
    slug: string;
    name: string;
    description: string;
    importUrl: string;
    instructionsTitle?: string;
    steps: InstructionStep[];
}

export const shortcuts: ShortcutItem[] = [
    {
        slug: "triple-tap",
        name: "Triple Tap Shortcut",
        description:
            "Quickly log expenses with a triple tap. Add this shortcut to your iPhone and run it to open TapSheet and record a transaction.",
        importUrl:
            "https://www.icloud.com/shortcuts/c1109facccfe4616a4d200005d76aa68",
        instructionsTitle: "How to set up the Triple Tap Shortcut",
        steps: [
            {
                title: "Import the shortcut",
                body: 'Tap the "Import Shortcut" button above to add the shortcut to your Shortcuts library.',
            },
            {
                title: "Add your API Key",
                body: 'On your iPhone, after clicking "Setup Shortcut" you\'ll see a prompt asking for your API Key. Copy and Paste the API key from your Profile page in the TapSheet app.',
            },
            {
                title: "Navigate to Settings",
                body: 'On your iPhone, navigate to Settings and search "Triple Tap". Scroll to the bottom and select the imported shortcut.',
            },
        ],
    },
    {
        slug: "apple-pay-automation",
        name: "Apple Pay Automation Shortcut",
        description:
            "Automatically log transactions when you physically tap your iPhone with Apple Pay. This shortcut can be triggered by an automation when you tap a card in your Apple wallet.",
        importUrl:
            "https://www.icloud.com/shortcuts/fff156b66f5d4802b952def63c43bda6",
        instructionsTitle: "How to set up the Apple Pay Automation Shortcut",
        steps: [
            {
                title: "Import the shortcut",
                body: 'Tap the "Import Shortcut" button above to add the shortcut to your iCloud Shortcuts library. Open the link on your iPhone to import it.',
            },
            {
                title: "Add your API Key",
                body: 'On your iPhone, after clicking "Setup Shortcut" you\'ll see a prompt asking for your API Key. Copy and Paste the API key from your Profile page in the TapSheet app.',
            },
            {
                title: "Create a personal automation",
                body: "In the Shortcuts app, go to Automation → tap the + button → Create Personal Automation. Select Wallet, then Select the Apple Pay Automation Shortcut to be triggered on the next screen.",
            },
            {
                title: "Run after confirming",
                body: 'Navigate to your created automation and ensure it is set to "Run After Confirmation". For the first run of this automation, otherwise you will encounter an error saying that the shortcut canoot run while phone is locked.',
            },
            {
                title: "After your first payment",
                body: "Once you have gone through your first run of the automation, you can change it to run immediately. This will let transactions be logged without needing confirmation. Then it will be truly automated. ",
            },
        ],
    },
];

export function getShortcutBySlug(slug: string): ShortcutItem | undefined {
    return shortcuts.find((s) => s.slug === slug);
}
